module.exports = __webpack_public_path__ + "img/hover_icon_reimbursement_direct_payment.11140a51.svg";